var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 727,
    height: 2,
    viewBox: "0 0 727 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H726",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeDasharray: "1 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLine);
export default __webpack_public_path__ + "static/media/dashLine.b5b2111705c2485f8073d2798a3efed4.svg";
export { ForwardRef as ReactComponent };